<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="13" height="12" viewBox="0 0 13 12" fill="none">
    <path d="M11.6629 11.3692L12.0321 11.7064L12.7064 10.9679L12.3371 10.6308L11.6629 11.3692ZM0.5 0.5L2.24598 6.00317L6.13888 1.73952L0.5 0.5ZM12.3371 10.6308L4.16032 3.16497L3.48605 3.90346L11.6629 11.3692L12.3371 10.6308Z" fill="white"/>
  </svg>
</template>